import React, {Component} from 'react';
import { DragDropContext } from 'react-beautiful-dnd';
import styled from 'styled-components';
import Column from './Column';
import CloseImage from './close.svg';


const Wrapper = styled.div`
display: flex;`;

const Container = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: wrap;
`;

const AddList = styled.label`
  display: flex;
  margin: 20px;
  background-color: ${(props) => !props.opened ? "#0a2c74" : 'white'};
  box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);
  -webkit-transition: all 150ms ease-in-out;
  transition: all 150ms ease-in-out;
  cursor: pointer;
  height: 100px;
  padding: 10px 40px;
  align-items: center;
`;

const Title = styled.h3`
`;

const CreateColumn = styled.input`
  padding: 11px 15px;
  font-size: 16px;
  border-radius: 5px;
  border: 2.5px solid rgba(255, 255, 255, 0.8);
  width: 100%;
  -webkit-box-shadow: 0 3px 3px rgba(0,0,0,0.16), 0 3px 3px rgba(0,0,0,0.23);
  box-shadow: 0 3px 3px rgba(0,0,0,0.16), 0 3px 3px rgba(0,0,0,0.23);
  width: 200px;
`;

const CloseButton = styled.button`
  background-color: transparent;
  background-image: url(${CloseImage});
  background-repeat: no-repeat;
  background-position: center;
  width: 34px;
  height: 34px;
  border: none;
`;



export default class Board extends Component {
  state= {
    opened: false
  }

  onClickHandler = (e) => {
    let { opened } = this.state;
    opened = !opened;
    this.setState(
      {
        opened: opened
      }
    )
  }

  render() {
    let addColumn = (
      <AddList data-name={this.props.name}>
        <Title onClick={this.onClickHandler}>Создать новую доску </Title>
      </AddList>);

    if(this.state.opened) {
      addColumn = (
      <AddList opened={this.state.opened} data-name={this.props.name}>
      <CreateColumn onKeyDown={this.props.create} type="text"/>
      <CloseButton onClick={this.onClickHandler} type="button"> </CloseButton>
      </AddList>
    )
    }

    if(Object.keys(this.props.data).length < 2) {
      return (
        <div>
          {addColumn}
        </div>
      )
    } else if(this.props.data.lastColumnId === 0) {
      return (
        <div>
          {addColumn}
        </div>
      )
    } else {
      return(
        <Wrapper>
          <DragDropContext key={this.props.board} onDragStart={this.props.dragStart} onDragEnd={this.props.dragEnd}>
              <Container>
              {
                  this.props.data.columnOrder.map(columnId => {
                    const column =  this.props.data.columns[columnId];
                    let tasks;
                    if(typeof column.taskIds !== 'undefined' && Object.keys(column.taskIds).length !== 0) {
                      tasks = column.taskIds.map(taskId => this.props.data.tasks[taskId]);
                    } else {
                      tasks = ['No tasks']
                    }
                    return <Column id={columnId} name={this.props.name} createTask={this.props.createTask} key={column.id} column={column} tasks={tasks}/>
                    })
                
              }
                {addColumn}
              </Container>
          </DragDropContext>

        </Wrapper>
      )
    }

    
  }
}